import React from "react";
import { Document, Page, View, Text, StyleSheet,Image } from "@react-pdf/renderer";
import { LOGO_IMG } from "../../../utills/image-constant";

// Styles for the PDF layout
const styles = StyleSheet.create({
  container: {
    padding: 20,
    fontFamily: "Helvetica",
  },
  titleContainer: {flexDirection: 'row',marginTop: 15,marginBottom: 25},
  spaceBetween : {
    flex : 1,
    flexDirection: 'row',
    alignItems:'center',
    justifyContent:'space-between',
    color: "#3E3E3E" 
  },
  addressTitle : {fontSize: 12, fontStyle: 'bold', textAlign: 'right',marginBottom: 10}, 
  addressTitlehead: {
     flex: 1,
      textAlign: 'right',
  },
  address : { fontWeight: 400, fontSize: 10,color:'red'},
  logo: { width: 90 },
  title: {
    fontSize: 14,
    marginBottom: 5,
    textAlign: "left",
    color: "#333",
  },
  tableWrapper: {
    marginTop: 20,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 5,
    marginBottom: 10,
  },
  th: {
    border: "1px solid #ddd",
    padding: 10,
    backgroundColor: "#e6f2ff",
    textAlign: "center",
    fontSize: 12,
  },
  td: {
    border: "1px solid #ddd",
    padding: 5,
    textAlign: "center",
  },
  row: {
    flexDirection: "row", // Align items horizontally
    alignItems: "center", // Vertically align the items in the center
    justifyContent: "center",
  },
  radioButton: {
    width: 10,
    height: 10,
    borderRadius: 50,
    borderWidth: 2,
    borderColor: "#ddd",
    marginRight: 10,
  },
  selectedRadioButton: {
    width: 20,
    height: 20,
    borderRadius: 50,
    backgroundColor: "#333",
    borderWidth: 3,
    borderColor: "#ddd",
    marginRight: 10,
  },
  text: {
    fontSize: 12,
  },
  sectionContainer: {
    flexDirection: "column", // Stack sections vertically on one page
    justifyContent: "space-between",
    marginBottom: 20, // Space between the two sections
  },
  section: {
    marginBottom: 20, // Space between items in a single section
    marginTop: 20, // Space between items in a single section
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    flex: 1,
    border: "1px solid #ddd",
    padding: 10,
    textAlign: "center",
  },
});

const renderContent = (option) => {
  switch (option) {
    case 'Initiating':
      return (
        <>
          Not at all Important
        </>
      );
    case 'Emerging':
      return (
        <>
        Low Importance
        </>
      );
      case 'Performing':
      return (
        <>
        Moderately Important
        </>
      );
      case 'Advancing':
      return (
        <>
      Highly Important
        </>
      );
      case 'Leading':
      return (
        <>
       Critically Important
        </>
      );
    default:
      return (
        <>
          {option} {/* Adjust `defaultText` to the correct property */}
        </>
      );
  }
};
// PDF Component
const PDFDocument = (props) => {
  const dataResult = props.dataResult;
  const companyName = props.companyName;
  const employeeName = props.employeeName;
  const remark = props.remark;
  
  
  const renderSection = (item,index) => (
    <View style={styles.section}>
      <Text style={styles.title}>{index + 1}) {item.question}.</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={[styles.th, { width: "33%" }]}>Current</Text>
          <Text style={[styles.th, { width: "33%" }]}>Future</Text>
          <Text style={[styles.th, { width: "33%" }]}>Importance</Text>
        </View>
        {item.optionResponseList.map((column, i) => (
          <View style={styles.tableRow} key={i}>
            <View style={styles.tableCell}>
              <View style={styles.row}>
                <View
                  style={[
                    styles.radioButton,
                    {
                      backgroundColor:
                        item.current === column ? "black" : "transparent",
                    },
                  ]}
                />
                <Text style={styles.text}>{column}</Text>
              </View>
            </View>
            <View style={styles.tableCell}>
              <View style={styles.row}>
                <View
                  style={[
                    styles.radioButton,
                    {
                      backgroundColor:
                        item.future === column ? "black" : "transparent",
                    },
                  ]}
                />
                <Text style={styles.text}>{column}</Text>
              </View>
            </View>
            <View style={styles.tableCell}>
              <View style={styles.row}>
                <View
                  style={[
                    styles.radioButton,
                    {
                      backgroundColor:
                        item.important === column ? "black" : "transparent",
                    },
                  ]}
                />
                <Text style={styles.text}> {renderContent(column)}</Text>
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
const HeaderBar = () => (
  <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
          <View>
               <Image style={styles.logo} src={LOGO_IMG} />
          </View>
          <View style={styles.addressTitlehead}>
              <Text style={styles.addressTitle}>Employee Name: {employeeName} </Text>
              <Text style={styles.addressTitle}>Company Name: {companyName}</Text>
          </View>
      </View>
  </View>
);

const Remark = () => (
  <View style={styles.titleContainer}>
      <View style={styles.spaceBetween}>
          <View >
              
              <Text style={styles.address}>
              Remark : {remark}
              </Text>
          </View>
         
      </View>
  </View>
);
  return (
    <Document>
      {dataResult.map((item, index) => {
        // Render two sections on the same page
        if (index % 2 === 0) {
          return (
            <Page size="A4" style={styles.container} key={index}>
              <View style={styles.sectionContainer}>
               {index === 0 && 
                    <>
                    <HeaderBar/>
                    {remark &&  <Remark/>  }
                    
                    </>
                  }
               
                {renderSection(item,index)} {/* First Section */}
                {dataResult[index + 1] && renderSection(dataResult[index + 1], index + 1)}
              </View>
            </Page>
          );
        }
        return null; // Ensure we're only rendering two sections at a time
      })}
    </Document>
  );
};

export default PDFDocument;
